/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import LoginLogo from '../assets/img/brand-icon.png';
import { loginStepOne, loginStepTwo } from '../services/auth';
import { userForgotPassword } from '../services/user';

import {
  setToken,
  setUserData,
  showToast,
  setLocation,
  setUserRole,
} from '../redux/auth/auth.action';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Footer from '../comman/component/footer';
import { ToastContainer, toast } from 'react-toastify';

const Login = ({
  setToken,
  setUserData,
  setToaster,
  setLocation,
  setUserRole,
}) => {
  const history = useHistory();

  const [buttonEvent, setButtonEvent] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);

  // password: 'ringerdev2023',
  //     username: 'ringerdev3@gmail.com',
  const initialValues =
    process.env.NODE_ENV === 'production'
      ? {
          username: '',
          password: '',
        }
      : {
          username: 'officialflashapp@gmail.com',
          password: 'startflashing',
        };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required('Username is required'),
    password: Yup.string()
      // .matches(
      //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      //   "Password must contain: numbers, special characters,uppercase and lowercase letters\n"
      // )
      .required('Password is required'),
  });

  const submitFunction = async (value) => {
    try {
      const forgotEmail = value.email;
      setButtonEvent(true);
      const response = await loginStepOne(value);
      if (response.status === 200) {
        await setToken(response.data.token);

        await setLocation(response.data.location);

        const responseStepTwo = await loginStepTwo();
        if (responseStepTwo.status === 200) {
          await setUserRole(
            responseStepTwo.data.userProfile.localizations.name.en.value
          );
          await setUserData(responseStepTwo.data);
          history.push('/index');
        }
      } else {
        const data = {
          show: true,
          message: 'Bad Credentials',
        };
        setToaster(data);
      }
      setButtonEvent(false);
    } catch (error) {
      const data = {
        show: true,
        message: 'Bad Credentials',
      };
      setToaster(data);
    }
  };

  const openForgotPassword = () => {
    // setForgotPassword(true);
    history.push('/forgotpassword');
  };
  const handleForgotEmail = async (e) => {
    const response = await userForgotPassword(e.email, e);

    if (response.status === 204) {
      toast('Mail Sent Successfully.Please Check your mail.');
    } else if (response.status === 401) {
      toast('Email is not valid.');
    }
  };
  return (
    <div id='pageWrapper'>
      <section className='sign-in-sec'>
        <div className='login-content-wrapper'>
          <div className='login-content-inner'>
            <div className='img'>
              <img src={LoginLogo} alt='' />
            </div>
            <div className='login-fileds'>
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(value) => submitFunction(value)}>
                {({ submitForm, values }) => (
                  <Form>
                    <div className='login-form'>
                      {/* {forgotPassword ? (
                        <>
                          <div className="input-item">
                            <Field
                              type="email"
                              name="email"
                              placeholder="Enter Email"
                            />
                          </div>
                          <div className="input-item login">
                            <button onClick={() => handleForgotEmail(values)}>
                              Submit
                            </button>
                          </div>
                          <ToastContainer
                            position="top-right"
                            // autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            limit={1}
                          />
                        </>
                      ) : ( */}
                      <>
                        <div className='input-item'>
                          <Field
                            type='text'
                            name='username'
                            placeholder='Enter Username'
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                submitForm();
                              }
                            }}
                          />
                          <ErrorMessage name='username'>
                            {(msg) => (
                              <span
                                className='fm_error'
                                style={{ color: 'red' }}>
                                {msg}
                              </span>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className='input-item'>
                          <Field
                            type='password'
                            name='password'
                            placeholder='Enter Password'
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                submitForm();
                              }
                            }}
                          />
                          <ErrorMessage name='password'>
                            {(msg) => (
                              <span
                                className='fm_error'
                                style={{ color: 'red' }}>
                                {msg}
                              </span>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className='input-item login'>
                          <button type='submit'>Login</button>
                        </div>
                      </>
                      {/*  )} */}
                      {/* {!forgotPassword ? ( */}
                      <div className='input-item login forget-password'>
                        <span type='submit' onClick={openForgotPassword}>
                          Forgot Password?
                        </span>
                      </div>
                      {/* ) : null} */}
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className='website-about-links'>
            <a
              href='https://ringerinteractive.com/privacy-policy/'
              target='_blank'
              rel='noreferrer'>
              Privacy Policy
            </a>
            {' | '}
            <a
              href='https://ringerinteractive.com/terms-and-conditions/'
              target='_blank'
              rel='noreferrer'>
              Terms of Service
            </a>
            {' | '}
            <a
              href='https://ringerinteractive.com/eula/'
              target='_blank'
              rel='noreferrer'>
              License Agreement
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setToken: (data) => dispatch(setToken(data)),
  setUserData: (data) => dispatch(setUserData(data)),
  setToaster: (data) => dispatch(showToast(data)),
  setLocation: (data) => dispatch(setLocation(data)),
  setUserRole: (data) => dispatch(setUserRole(data)),
});

export default connect(null, mapDispatchToProps)(Login);
